import { LazyErrorBoundary, LazyLoadingFallback, LazyReactMarkdown } from '@/lib/lazy-components'
import { cn } from '@/lib/utils'
import React from 'react'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'

export function Markdown({
  children,
  className,
}: Readonly<{ children?: string | null; className?: string }>) {
  return (
    <LazyErrorBoundary>
      <React.Suspense fallback={<LazyLoadingFallback className='h-20' />}>
        <LazyReactMarkdown
          components={{
            a: ({ children, target, ...props }) => (
              <a target='_blank' rel='noreferrer' {...props}>
                {children}
              </a>
            ),
            code: ({ children, ...props }) => (
              <code {...props} style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                {children}
              </code>
            ),
          }}
          className={cn(
            'flex w-full flex-col gap-2 break-words font-light [&_a]:text-grey-400 [&_a]:underline [&_h1]:text-xl [&_h1]:font-bold [&_h2]:text-lg [&_h2]:font-bold [&_h3]:text-base [&_h3]:font-bold [&_li_li]:pl-7 [&_li_p]:inline [&_ol]:list-inside [&_ul]:list-inside',
            className,
          )}
          rehypePlugins={[rehypeRaw]}
          remarkPlugins={[remarkGfm]}
        >
          {children}
        </LazyReactMarkdown>
      </React.Suspense>
    </LazyErrorBoundary>
  )
}
